module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FooterContact":{"email":{"label":"E-mail:"},"phone":{"label":"Telefon:"},"title":"Kontakt"}},"en":{"FooterContact":{"title":"Contact"}}}')
  delete Component.options._Ctor
}
